<template>
  <Layout>
    <div class="row">
      <PageHeader class="col-11" title="Challan Management" />
    </div>

    <!-- Statistics -->
    <div class="row">
      <div class="col-sm-4">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-3">
                <p class="text-muted mb-2">
                  Total Challans
                </p>
                <h5 class="mb-0">{{ challanStatistics.totalChallanCount }}</h5>
              </div>

              <div class="avatar-sm ms-auto">
                <div class="
                    avatar-title
                    bg-light
                    rounded-circle
                    text-warning
                    font-size-20
                  ">
                  <i class="bx bxs-receipt"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-3">
                <p class="text-muted mb-2">
                  NIC Sent Challans
                </p>
                <h5 class="mb-0">{{ challanStatistics.totalNicSent }}</h5>
              </div>

              <div class="avatar-sm ms-auto">
                <div class="
                    avatar-title
                    bg-light
                    rounded-circle
                    text-success
                    font-size-20
                  ">
                  <i class="bx bxs-badge-check"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-3">
                <p class="text-muted mb-2">
                  NIC Pending Challans
                </p>
                <h5 class="mb-0">{{ challanStatistics.totalNicNotSent }}</h5>
              </div>

              <div class="avatar-sm ms-auto">
                <div class="
                    avatar-title
                    bg-light
                    rounded-circle
                    text-danger
                    font-size-20
                  ">
                  <i class="bx bxs-x-circle"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- challan table -->
    <b-table class="datatables" :items="allChallans" :fields="fields" responsive="sm" :per-page="0"
      :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :filter="filter"
      :filter-included-fields="filterOn" @filtered="onFiltered">
      <template #cell(plate_no)="row">
        {{ !row.item.plate_no ? "NA" : row.item.plate_no }}
      </template>
      <template #cell(offence_id)="row">
        {{ !row.item.offence_id ? "NA" : offenceMaster.find(o => o.offence_id === row.item.offence_id).offence }}
      </template>
      <template #cell(is_nic_sent)="row">
        <span v-if="row.item.is_nic_sent === 1" :class="`badge ${getStatusClass(row.item.is_nic_sent)}`">
          Sent
        </span>
        <span v-if="row.item.is_nic_sent === 0" :class="`badge ${getStatusClass(row.item.is_nic_sent)}`">
          In Progress
        </span>
      </template>

      <template #cell(challan_status)="row">
        <span :class="`badge ${getChallanStatusClass(row.item.challan_status)}`">{{ row.item.challan_status }}</span>
      </template>

      <template #cell(actions)="row">
        <b-button size="sm" variant="primary" class="m-1" @click="showChallanDetails(row.item)"
          :disabled="disableMoreBtn">
          More Details <i class="fa fa-arrow-right ml-2"></i>
        </b-button>
      </template>
    </b-table>

    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-end mb-3">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
          </ul>
        </div>
      </div>
    </div>

    <!-- challan details modal -->
    <b-modal id="more-details-modal" size="lg" title-class="font-18" hide-footer centered>
      <template #modal-header>
        <div>
          <h5>Challan Details</h5>
        </div>
        <div>
          <button class="btn btn-sm btn-outline-danger m-2" @click="$bvModal.hide('more-details-modal')">
            <i class="mdi mdi-close"></i>
          </button>
        </div>
      </template>

      <!-- <ChallanForm :incidentDetails="selectedChallan" @close="$bvModal.hide('more-details-modal')" /> -->
      <div class="row" v-if="selectedChallan && selectedChallan.incident">
        <div class="col-6">
          <b-list-group>
            <b-list-group-item class="d-flex">
              <span class="col-6">ID</span>
              <span class="col-6">{{ selectedChallan.id }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex">
              <span class="col-6">NIC ID</span>
              <span class="col-6">{{ selectedChallan.transaction_id }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex">
              <span class="col-6">NIC Status</span>
              <span class="col-6">
                <span v-if="selectedChallan.is_nic_sent === 1"
                  :class="`badge ${getStatusClass(selectedChallan.is_nic_sent)}`">
                  Sent
                </span>
                <span v-if="selectedChallan.is_nic_sent === 0"
                  :class="`badge ${getStatusClass(selectedChallan.is_nic_sent)}`">
                  In Progress
                </span>
              </span>
            </b-list-group-item>
            <b-list-group-item class="d-flex">
              <span class="col-6">Vehicle No.</span>
              <span class="col-6">{{ !selectedChallan.plate_no ? !selectedChallan.incident.plate_no ? "NA" :
                selectedChallan.incident.plate_no : selectedChallan.plate_no }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex">
              <span class="col-6">Vehicle Class</span>
              <span class="col-6">{{ !selectedChallan.incident.type ? "NA" : selectedChallan.incident.type }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex">
              <span class="col-6">Offence</span>
              <span class="col-6">{{ !selectedChallan.offence_id ? "NA" : offenceMaster.find(o => o.offence_id ===
                selectedChallan.offence_id).offence }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex">
              <span class="col-6">Violation Source</span>
              <span class="col-6">{{ String(selectedChallan.event_type).toUpperCase() }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex">
              <span class="col-6">Relevant Event ID</span>
              <span class="col-6">{{ selectedChallan.event_id }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex">
              <span class="col-6">Vehicle Speed</span>
              <span class="col-6">{{ selectedChallan.vehicle_speed == 0 ? 'NA' : selectedChallan.vehicle_speed + ' km/hr'
              }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex">
              <span class="col-6">Date | Time</span>
              <span class="col-6">{{ getReadableDateTime(selectedChallan.created_at) }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex">
              <span class="col-6">Department</span>
              <span class="col-6">{{ selectedChallan.department }}</span>
            </b-list-group-item>
          </b-list-group>
        </div>
        <div class="col-6">
          <b-list-group>
            <b-list-group-item class="d-flex">
              <span class="col-6">District Code</span>
              <span class="col-6">{{ districtMaster && selectedChallan.district_code ? districtMaster.find(d =>
                d.district_id ==
                selectedChallan.district_code).name : selectedChallan.district_code
              }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex">
              <span class="col-6">State Code</span>
              <span class="col-6">{{ selectedChallan.state_code }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex">
              <span class="col-6">RTO Code</span>
              <span class="col-6">{{ selectedChallan.rto_code }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex">
              <span class="col-6">User ID</span>
              <span class="col-6">{{ selectedChallan.user_id }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex">
              <span class="col-6">Vendor Name</span>
              <span class="col-6">{{ selectedChallan.vendor_name }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex">
              <span class="col-6">Operator ID</span>
              <span class="col-6">{{ selectedChallan.operator_id }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex">
              <span class="col-6">Location</span>
              <span class="col-6">{{ selectedChallan.incident.location }} {{ selectedChallan.incident.side }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex">
              <span class="col-6">Comment</span>
              <span class="col-6">{{ !selectedChallan.comment ? 'NA' : selectedChallan.comment }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex">
              <div class="col-12">
                <span class="mb-2">Images: </span><br />
                <img class="mt-2" v-for="(src, index) in challanImages" :key="index" width="100" style="cursor: pointer;"
                  @click="() => showImageModal(index)" :src="src" />
              </div>
            </b-list-group-item>
          </b-list-group>
        </div>
      </div>
      <vue-easy-lightbox :visible="showImage" :imgs="challanImages" :index="showImageIndex"
        @hide="hideImageModal"></vue-easy-lightbox>
    </b-modal>
  </Layout>
</template>

<script>
import Layout from "@/layouts/main";
import PageHeader from "@/components/page-header";
import incidentMixin from "../../mixins/incident";
import VueEasyLightbox from "vue-easy-lightbox";
import DatePicker from "vue2-datepicker";
import ChallanForm from '@/components/incidents/challan-form'
import Swal from "sweetalert2";
import config from '../../constants/config'

export default {
  page: {
    title: "Challan Management"
  },

  mixins: [incidentMixin],

  components: {
    Layout,
    PageHeader,
    VueEasyLightbox,
    DatePicker,
    ChallanForm
  },

  data () {
    return {
      config: config,
      allChallans: [],
      currentPage: 1,
      perPage: 20,
      totalRows: 1,
      sortBy: "id",
      sortDesc: true,
      filterOn: [],
      filter: null,
      selectedChallan: {},
      disableMoreBtn: false,
      showImage: false,
      showImageIndex: 1,
      socketInterval: null,
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "transaction_id",
          label: "NIC Txn ID",
          sortable: false,
        },
        {
          key: "plate_no",
          label: "Plate No.",
          sortable: false,
        },
        {
          key: "offence_id",
          label: "Offence",
          sortable: true,
        },
        {
          key: "vehicle_speed",
          label: "Speed",
          sortable: false,
          formatter: (value) => {
            return value == 0 ? 'NA' : value
          },
        },
        {
          key: "event_type",
          label: "Event Source",
          sortable: false,
          formatter: (value) => {
            return String(value).toUpperCase();
          },
        },
        {
          key: "created_at",
          label: "Date | Time",
          sortable: true,
          formatter: (value) => {
            return this.getReadableDateTime(value);
          },
        },
        {
          key: "is_nic_sent",
          label: "NIC Status",
          sortable: false,
        },
        {
          key: "actions",
          sortable: false,
          label: "Action",
        },
      ],
    };
  },

  async mounted () {
    // await this.getAllIncidents(this.currentPage);
    this.$socket.emit("REQUEST:CHALLAN_STATISTICS");
    this.$socket.emit("REQUEST:CHALLAN_RECORDS");

    this.socketInterval = setInterval(() => {
      this.$socket.emit("REQUEST:CHALLAN_STATISTICS");

      if (!this.isDataFilterActive) {
        if (this.currentPage == 1) {
          this.$socket.emit("REQUEST:CHALLAN_RECORDS");
        }
      }
    }, 5000);
  },

  beforeDestroy () {
    if (this.socketInterval) {
      clearInterval(this.socketInterval);
      this.socketInterval = null;
    }
  },

  computed: {
    masters () {
      return this.$store.getters["incident/masters"];
    },
    challanStatistics () {
      return this.$store.getters["socket/challans"].statistics;
    },
    challanRecords () {
      return this.$store.getters["socket/challans"].data;
    },
    offenceMaster () {
      return this.masters.offenceIdMaster
    },
    districtMaster () {
      return this.masters.districtCodeMaster
    },
    challanImages () {
      return this.selectedChallan.incident && this.selectedChallan.incident.image_url
        ? [`${config.CLIENT_URL}${this.selectedChallan.incident.image_url}`]
        : [];
    },
  },

  watch: {
    currentPage: async function () {
      await this.getAllIncidents(this.currentPage);
    },
    challanRecords: async function () {
      this.allChallans = this.challanRecords.data;
      this.perPage = this.challanRecords.rows;
      this.totalRows = this.challanRecords.totalPageNumber;
    },
  },

  methods: {
    showImageModal (index) {
      this.showImageIndex = index;
      this.showImage = true;
    },
    hideImageModal () {
      this.showImage = false;
    },

    async getAllIncidents (page) {
      const result = await this.GetChallans(page);
      this.allChallans = result.data;
      this.perPage = result.rows;
      this.totalRows = result.totalPageNumber;
    },

    getReadableDateTime (dateTime) {
      if (dateTime) {
        return `${new Date(dateTime).toLocaleString()}`;
      }
    },

    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    getStatusClass (status) {
      switch (status) {
        case "Open":
          return "bg-danger";

        case 0:
          return "bg-warning";

        case 1:
          return "bg-success";

        case "Closed":
          return "bg-success";

        default:
          return "bg-info";
      }
    },

    getChallanStatusClass (status) {
      switch (status) {
        case "Generated":
          return "bg-primary";

        case "Not Generated":
          return "bg-danger";

        case "Paid":
          return "bg-success";

        case "Unpaid":
          return "bg-warning";

        case "Sent":
          return "bg-info";

        default:
          return "bg-info";
      }
    },

    async showChallanDetails (challan) {
      this.disableMoreBtn = true
      try {
        this.selectedChallan = challan;
        const incident = await this.GetIncidentByTypeID(challan.event_type, challan.event_id)
        this.selectedChallan = { ...this.selectedChallan, incident }
        this.$bvModal.show("more-details-modal");
      } catch (e) {
        Swal.fire('Oops! Something went wrong', 'Failed to fetch incident details: ' + e.response.data.message, 'error')
      }

      this.disableMoreBtn = false
    },
  },
};
</script>